import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';


import { originalEmailActions } from '../actions/originalEmail';
const {
  originalEmailGet,
  originalEmailGetSucceeded,
  originalEmailGetFailed,
  originalEmailCloseModal,
  originalEmailGetHtmlMessage,
  originalEmailGetHtmlMessageSucceeded,
  originalEmailGetHtmlMessageFailed,
  originalEmailGetPrinterFriendly,
  originalEmailGetPrinterFriendlySucceeded,
  originalEmailGetPrinterFriendlyFailed,
} = originalEmailActions;

export type OriginalEmailState = {
  meta: {
    fetchOriginalEmail: AsyncStatus;
    printerFriendly: AsyncStatus;
    htmlMessage: AsyncStatus;
  };
  ui: {
    showModal: boolean;
  };
  currentOriginalEmail: any;
};

// Init state for the Typing.
const initialState: OriginalEmailState = {
  meta: {
    fetchOriginalEmail: 'succeeded',
    printerFriendly: 'succeeded',
    htmlMessage: 'succeeded',
  },
  ui: {
    showModal: false,
  },
  currentOriginalEmail: null,
};

// Reducer
const originalEmail = handleActions<OriginalEmailState, any>(
  {
    [originalEmailGetHtmlMessage.toString()]: (state: OriginalEmailState) => {
      return { ...state, meta: { ...state.meta, htmlMessage: 'loading' } };
    },

    [originalEmailGetHtmlMessageSucceeded.toString()]: (
      state: OriginalEmailState,
    ) => {
      return { ...state, meta: { ...state.meta, htmlMessage: 'succeeded' } };
    },

    [originalEmailGetHtmlMessageFailed.toString()]: (
      state: OriginalEmailState,
    ) => {
      return { ...state, meta: { ...state.meta, htmlMessage: 'failed' } };
    },

    [originalEmailGet.toString()]: (state: OriginalEmailState) => {
      return {
        ...state,
        meta: { ...state.meta, fetchOriginalEmail: 'loading' },
      };
    },

    [originalEmailGetSucceeded.toString()]: (
      state: OriginalEmailState,
      action: any,
    ) => {
      return {
        ...state,
        meta: { ...state.meta, fetchOriginalEmail: 'succeeded' },
        ui: {
          showModal: true,
        },
        currentOriginalEmail: Object.assign({}, action.payload),
      };
    },

    [originalEmailGetFailed.toString()]: (state: OriginalEmailState) => {
      return {
        ...state,
        meta: { ...state.meta, fetchOriginalEmail: 'failed' },
      };
    },

    [originalEmailGetPrinterFriendly.toString()]: (
      state: OriginalEmailState,
    ) => {
      return { ...state, meta: { ...state.meta, printerFriendly: 'loading' } };
    },

    [originalEmailGetPrinterFriendlySucceeded.toString()]: (
      state: OriginalEmailState,
      action: any,
    ) => {
      return {
        ...state,
        meta: { ...state.meta, printerFriendly: 'succeeded' },
        currentOriginalEmail: Object.assign({}, action.payload),
      };
    },

    [originalEmailGetPrinterFriendlyFailed.toString()]: (
      state: OriginalEmailState,
    ) => {
      return { ...state, meta: { ...state.meta, printerFriendly: 'failed' } };
    },

    [originalEmailCloseModal.toString()]: (state: OriginalEmailState) => {
      return {
        ...state,
        ui: {
          showModal: false,
        },
        currentOriginalEmail: null,
      };
    },
  },
  initialState,
);

export default originalEmail;
